import React from 'react';
import './style.scss';
import { AnimatedHeading, HoverText } from '../../shared/TextFx';
import { useModal } from '../../shared/ModalContext';
import contactImage from './../../assets/contact-image.png';

// TODO: replace with your real 24/7 Operations number
const OPS_PHONE = '+910000000000';

const ContactSec = () => {
  const { openModal } = useModal();

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact__container scale-block">
          <div className="contact__top opacity-block">
            <span className="contact__top-text">Operations 24/7</span>
            <span className="contact__top-text">When does the shipment need to arrive?</span>
          </div>

          <AnimatedHeading
            className="contact__title"
            text="Tell us the delivery time. We'll build the movement around it."
          />

          <div className="contact__container-inner opacity-block">
            <p className="contact__text">
              Share the shipment details and required delivery time with our Operations team.
              We'll evaluate the available movement and determine the fastest viable route.
            </p>

            <div className="contact__actions">
              <button
                aria-label="Start my shipment"
                className="contact__btn text-hover btn _accent"
                onClick={openModal}
                type="button"
              >
                <span className="btn__inner">
                  <HoverText words="Start My Shipment" />
                </span>
              </button>

              <a
                aria-label="Talk to Operations 24/7"
                className="contact__btn contact__btn--secondary text-hover btn"
                href={`tel:${OPS_PHONE}`}
              >
                <span className="btn__inner">
                  <HoverText words="Talk to Operations 24/7" />
                </span>
              </a>
            </div>
          </div>

          <div className="contatc-img-div">
            <img src={contactImage} className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSec;
